<script>
	import { flip } from 'svelte/animate';
	import { fly } from 'svelte/transition';
	import { toastAlertStore } from '#/stores/toastAlert.svelte.js';
</script>

{#each $toastAlertStore as toast (toast.id)}
	<div
		id="toast-alert"
		role="alert"
		class="alert alert-{toast.variant}
		       z-[9999] fixed
		       left-1/2 top-[100px]
		       -translate-x-1/2
		       max-w-md
		       w-fit
		       px-8
					 rounded-s"
		animate:flip
		transition:fly={{ y: 30 }}
	>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			class="h-6 w-6 shrink-0 stroke-current"
		>
			<path
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="2"
				d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
			></path>
		</svg>
		<span>{toast.message}</span>
	</div>
{/each}
